export const nativeApi = window.desktopAPI;
export const platform = nativeApi === undefined ? 'web' : 'desktop';
